import segmentProps from '../lib/segmentProps';

export default {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_mortgage_illustration_updated',
            props: {
                ...segmentProps,
                provider: 'Habito',
                mortgage_type: '@mortgageApplication.kind',
                remortgage_type: '@mortgageApplication.type',
                property_value: '@mortgageApplication.residenceValue',
                remaining_balance: '@mortgageApplication.currentBalance',
                years_left_on_mortgage: '@mortgageApplication.yearsLeft',
                deal_type: '@mortgageApplication.product',
                offer_period: '@mortgageApplication.offerTerm',
                repayment_option: '@mortgageApplication.repayment',
            },
        },
    },
    dictionary: {
        remortgage: 'remortgage',
        newMortgage: 'new_mortgage',
    },
};
